// ReduxAccessModules.tsx
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the type for an access module
export interface AccessModule {
  id?: string | number;
  name?: string;
  code?: string;
  parentId?: string | number | null;
  level?: number;
  path?: string;
  icon?: string;
  order?: number;
  isActive?: boolean;
  children?: AccessModule[];
  permissions?: {
    canView?: boolean;
    canAdd?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
    canApprove?: boolean;
    [key: string]: boolean | undefined;
  };
  [key: string]: any;
}

// Define the type for the state
export type AccessModulesState = AccessModule[];

// Define initial state
const initialState: AccessModulesState = [];

// Create the slice
const accessModulesSlice = createSlice({
  name: "accessModules",
  initialState,
  reducers: {
    setAccessModules: (state, action: PayloadAction<AccessModule[]>) => {
      console.log("Access modules payload received:", action.payload);
      return action.payload;
    },
    clearAccessModules: (): AccessModulesState => {
      return [];
    },
    // Optional: Add other actions as needed
    addAccessModule: (state, action: PayloadAction<AccessModule>) => {
      state.push(action.payload);
    },
    updateAccessModule: (state, action: PayloadAction<{ id: string | number; updates: Partial<AccessModule> }>) => {
      const { id, updates } = action.payload;
      const index = state.findIndex(module => module.id === id);
      if (index !== -1) {
        state[index] = { ...state[index], ...updates };
      }
    },
    removeAccessModule: (state, action: PayloadAction<string | number>) => {
      return state.filter(module => module.id !== action.payload);
    },
  },
});

// Export actions for use in components
export const { 
  setAccessModules, 
  clearAccessModules,  // Make sure this is exported
  addAccessModule,
  updateAccessModule,
  removeAccessModule 
} = accessModulesSlice.actions;

// Export selector
export const selectAccessModules = (state: { accessModules: AccessModulesState }): AccessModule[] => 
  state.accessModules;

// Export reducer
export default accessModulesSlice.reducer;